<template>
    <div>
        <SlackIntegrationModal
            v-if="slackIntegrationModalOpened"
            :integration="selectedIntegration"
            @close="
                ((slackIntegrationModalOpened = false),
                (selectedIntegration = undefined))
            "
        />

        <TeamsIntegrationModal
            v-if="teamsIntegrationModalOpened"
            :integration="selectedIntegration"
            @close="
                ((teamsIntegrationModalOpened = false),
                (selectedIntegration = undefined))
            "
        />
    </div>
</template>

<script lang="ts" setup>
import useIntegrations from "../composables/useIntegrations";

const {
    slackIntegrationModalOpened,
    teamsIntegrationModalOpened,
    selectedIntegration,
} = useIntegrations();
</script>
